import React from "react";
import { Link, withRouter } from "react-router-dom";
import {Badge} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';

import UiTM_icon from '../assets/images/contents/UiTM_Icon.png';

export var Navigation = function(props){
    return(
        <div className="navigation">
            <nav class="navbar navbar-expand-lg navbar-dark bg-primary" 
                style={{"box-shadow": "10px 10px 5px grey", "margin-top": "10px", padding: ".5rem, 12rem"}}>
                <div class="container">
                    <Link class="navbar-brand" to="/">
                    <img 
                        position="absolute"
                        src={UiTM_icon}
                        height= "100%" 
                        width= "100%" 
                        className="d-inline-block align-top"
                        alt="UiTM logo"
                    />
                    </Link>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" 
                        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto">
                            <li className="nav-item">
                                <Link class="nav-link" to="/scds2021/home">Home
                                    <span class="sr-only">(current)</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link class="nav-link" to="/scds2021/callPapers">Call for Papers</Link>
                            </li>
                            <li className="nav-item">
                                <Link class="nav-link" to="/scds2021/dates">Important Dates</Link>
                            </li>
                            <li className="nav-item">
                                <Link class="nav-link" to="/scds2021/proceeding">Proceeding <Badge pill variant="danger">New</Badge>{" "}</Link>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="/" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Information
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2021/programBook" style={{color: 'black'}}>Program Book </Link>
                                    </li>
                                    <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2021/submissionGuideline" style={{color: 'black'}}>Submission Guideline </Link>
                                    </li>
                                    <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2021/committee" style={{color: 'black'}}>Technical Committee</Link>                              
                                    </li>
                                    <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2021/feePayment" style={{color: 'black'}}>Fee and Payment</Link>
                                    </li>
                                    <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2021/registration" style={{color: 'black'}}>Registration</Link>
                                    </li>
                                    <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2021/publication" style={{color: 'black'}}>Publication</Link>
                                    </li>
                                    <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2021/venue" style={{color: 'black'}}>Venue & Accommodation</Link>
                                    </li>
                                    <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2021/visa" style={{color: 'black'}}>Visas & Letter of Invitation</Link>
                                    </li>
                                    <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2021/bestPaper" style={{color: 'black'}}>Best Paper Award <Badge pill variant="danger">New</Badge>{" "}</Link>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="/" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Committee
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2021/committee" style={{color: 'black'}}>Technical Committee</Link>                           
                                    </li>
                                    <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2021/organizer" style={{color: 'black'}}>International Scientific Committee</Link>                              
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="/" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    About
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2021/previousscds" style={{color: 'black'}}>Previous SCDS</Link>                                 
                                    </li>
                                    <li class="dropdown-item">
                                        <Link class="nav-link" to="/scds2021/contact" style={{color: 'black'}}>Contact Us</Link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
}

export default withRouter(Navigation);